import { useAuth } from '../contexts/AuthContext';

/**
 * Company info pre-fill comes from the partner session profile.
 * POST /admin/partner-login already runs during partner login / session restore —
 * no second login call is needed here.
 */
export const usePartnerCompanyInfoQuery = () => {
  const { isPartner, partnerProfile, loading } = useAuth();

  return {
    data: partnerProfile,
    isLoading: loading,
    isError: !loading && isPartner && !partnerProfile,
    error:
      !loading && isPartner && !partnerProfile ? new Error('Partner profile unavailable') : null,
  };
};
